import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { includes, noop } from 'lodash';
import styles from './vertical-card.scss';
import { ItemType } from '@wix/wix-vod-constants/api-types';
import { CardDescription } from './description/description';
import { CardCTA } from './cta/cta';
import { CardThumbnailPlaceholderIcon, PLAYABLE_VIDEO_CARD_TYPES, } from './thumbnail-placeholder-icon/thumbnail-placeholder-icon';
import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/video-cards';
export const VERTICAL_VIDEO_CARD_WIDTH = 210;
export class VerticalVideoCard extends React.Component {
    constructor() {
        super(...arguments);
        this.handleCardClick = () => {
            const { cardData, onCardClick } = this.props;
            onCardClick(cardData);
        };
    }
    isScheduledVideo() {
        const { itemType } = this.props.cardData;
        return itemType === ItemType.ItemScheduled;
    }
    hasCTA() {
        const { cardData: { buttonLabel, network }, } = this.props;
        return Boolean(buttonLabel || network) && !this.isScheduledVideo();
    }
    renderThumbnail() {
        const { cardData: { thumbnailUrl, type, itemType }, } = this.props;
        const isPlayable = includes(PLAYABLE_VIDEO_CARD_TYPES, type);
        const style = thumbnailUrl
            ? { backgroundImage: `url(${thumbnailUrl})` }
            : null;
        const thumbnailClassNames = classnames(styles.thumbnail, {
            [styles['with-play-icon']]: isPlayable && thumbnailUrl,
        });
        return (React.createElement("div", { className: thumbnailClassNames, style: style },
            React.createElement("div", { className: styles.icon },
                React.createElement(CardThumbnailPlaceholderIcon, { type: type, itemType: itemType, thumbnailUrl: thumbnailUrl }))));
    }
    render() {
        const { cardData, className, isAccessible, labels } = this.props;
        const { text, url, type, liveLabel } = cardData;
        const hasCTA = this.hasCTA();
        const isSocialCard = type === VIDEO_CARD_TYPES.SOCIAL;
        const linkClassNames = classnames(styles.link, {
            [styles['is-social-card']]: isSocialCard,
        });
        return (React.createElement("div", { className: className, tabIndex: "-1", "data-hook": "action-card" },
            React.createElement("a", { className: linkClassNames, onClick: this.handleCardClick, href: url, "aria-hidden": !isAccessible, tabIndex: isAccessible ? 0 : -1, rel: "noopener noreferrer", target: "_blank" },
                React.createElement("div", { className: styles.container },
                    this.renderThumbnail(),
                    React.createElement("div", { className: styles['content-wrapper'] },
                        React.createElement("div", { className: styles.content },
                            React.createElement("div", { className: styles.description }, text && (React.createElement(CardDescription, { text: text, liveLabel: liveLabel, isShrinkable: isSocialCard, withSeparator: isSocialCard ? false : hasCTA }))),
                            hasCTA && (React.createElement(CardCTA, { labels: labels, isAccessible: isAccessible, cardData: cardData }))))))));
    }
}
VerticalVideoCard.propTypes = {
    className: PropTypes.string,
    isAccessible: PropTypes.bool,
    cardData: PropTypes.object,
    onCardClick: PropTypes.func,
    labels: PropTypes.object,
};
VerticalVideoCard.defaultProps = {
    onCardClick: noop,
};
//# sourceMappingURL=vertical-card.js.map